import {Box, Text, Image, Heading, Center, Flex} from '@chakra-ui/react';
import * as React from 'react';
import {SlideInBox} from './slide-in-box';

interface BanksyNftBannerProps {
  desktopImage: string;
  mobileImage: string;
}
export const BanksyNftBanner: React.FC<BanksyNftBannerProps> = ({
  desktopImage,
  mobileImage,
}) => {
  return (
    <Center position="relative" overflow="hidden">
      <Box display="inline-block" position="relative">
        <Image
          display={{base: 'none', md: 'block'}}
          src={desktopImage}
          alt="banksy valentines day mascara"
          maxWidth="100%"
          height="1195px"
          objectFit="cover"
          objectPosition="top center"
        />
        <Image
          display={{base: 'block', md: 'none'}}
          src={mobileImage}
          alt="banksy valentines day mascara"
          width="100%"
          height="581px"
          objectFit="cover"
          objectPosition="top center"
        />

        <Flex
          color="white"
          position="absolute"
          left="0"
          width="100%"
          justifyContent="center"
          alignItems="flex-start"
          top={{base: '190px', md: '300px'}}
        >
          <Box
            maxWidth={{base: '400px', md: '1150px'}}
            pl={{base: '70px', sm: '125px', md: '250px', lg: '400px'}}
          >
            <SlideInBox>
              <Heading
                color="aqua.700"
                fontSize={{base: '25px', md: '55px', lg: '70px'}}
                zIndex={5}
              >
                Immerse yourself virtually in Banksy
              </Heading>
            </SlideInBox>
            <Text
              fontSize={{base: '18px', md: '30px'}}
              fontWeight={600}
              zIndex={5}
              pr={10}
            >
              The Valentine’s Day Mascara experience powered by Futura Art
            </Text>
          </Box>
        </Flex>
      </Box>
    </Center>
  );
};
